<template>
    <PlazosImpagados :plazos="plazos" :lista_id="lista_id" :filters.sync="filters" @actualizado="getPlazos"/>
</template>

<script>
    import PlazosImpagados from '@/components/backend/components/plazos/PlazosImpagados';

    export default {
        props: ['lista_id'],
        data() {
            return {
                plazos: { meta: { current_page: 1 } },
                categorias: [],
                loading: false,
                filters: {
                    per_page: 10,
                    page: 1,
                    estado: '',
                    fecha: ''
                },
            }
        },
        methods: {
            getPlazos() {
                this.loading = true;
                
                let params = {
                    filters: this.filters,
                    lista_id: this.lista_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.plazos-impagados.abonos'), params).then(res => {
                    this.plazos = res.data;
                }).finally(() => this.loading = false);
            }
        },
        created(){
            this.getPlazos();
        },
        components: {
            PlazosImpagados
        }
    }
</script>